import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=72a2d918&scoped=true&lang=pug&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a2d918",
  null
  
)

export default component.exports